import type { Reducer } from 'Lib/reduxType';

import { LOAD_INTL_MESSAGES_SUCCESS } from './constants';
import type { IntlMessagesState } from './types';

export const initialState: IntlMessagesState = {};

export const reducer: Reducer<IntlMessagesState> = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_INTL_MESSAGES_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
